import React from 'react'
// import { Link } from 'react-router-dom'
// import './error.scss'
import CertImg from './certification.png';
// import {lightblue} from "color-name";

type Props = {}

const data = [
    {
        label: "CISCO SYSTEMS, INC. CERTIFICATION AND CONFIDENTIALITY AGREEMENT",
        link: ""
    },
    {
        label: "CISCO CERTIFICATIONS TRADEMARK AGREEMENT",
        link: ""
    },
    {
        label: "Code of Certification Ethics",
        link: ""
    },
    {
        label: "Pearson VUE Candidate Rules Agreement",
        link: ""
    },
];

const CertificationPage: React.FC<Props> = () => {
    return (
        <div className="certification">
            <h1 className={"flex-center"}>
                <img className={"w-12 mr-6 flex"} src={CertImg} alt="Certification"/>
                Certification
            </h1>
            <ul>
                {
                    data.map((item)=>{
                        return <li key={item.label}>
                            <a href={item.link}>{item.label}</a>
                        </li>
                    })
                }
            </ul>
            {/*<Link to="/" > Go to Homepage </Link>*/}
        </div>
    )
};


export default CertificationPage;
